import React, { useState, useEffect } from 'react';

import Icon from '../../ui/icon';

const ClipboardArea = ({ bamLink, bamLinkTruncated }) => {
  const [copyStatus, setCopyStatus] = useState(false);

  useEffect(() => {
    if (copyStatus) setTimeout(() => setCopyStatus(false), 1000);
  }, [copyStatus]);

  function copyLink() {
    navigator.clipboard.writeText(bamLink);
    setCopyStatus(true);
  }

  const copyIcon = copyStatus ? null : <Icon iconName={`copy`} size={13} />;

  return (
    <div className="link-details">
      <span className={`link ${copyStatus ? 'highlight' : ''}`}>{bamLinkTruncated}</span>
      {/* TODO leave out until auction status feature is finalized */}
      {/* <span className={`${statusColor}`}>{monetizeableStatus}</span> */}
      <button className={`clipboard-btn ${copyStatus ? 'filled' : ''}`} onClick={copyLink}>
        {copyIcon}
        <span className="clipboard-text">{copyStatus ? 'Copied!' : 'Copy'}</span>
      </button>
    </div>
  );
};

export default ClipboardArea;
